import React, { useContext, useState } from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import API from '../../../services/API'
import { GlobalContext } from '../../../App'
import EmployeeSelector from '../../events/EmployeeSelector'
import GapSeverityChip from '../components/GapSeverityChip'

// Deliberately minimal: pick who will fix the gap, nothing else. The gap
// itself is the work item - no titles, due dates or separate task records -
// and the assignment ends automatically when the gap resolves.
const AssignGapDialog = ({ gap, onClose, onSaved }) => {
  const { setToast } = useContext(GlobalContext)
  const [assignee, setAssignee] = useState(gap.assignedTo ?? null)
  const [saving, setSaving] = useState(false)

  const save = () => {
    setSaving(true)
    API.put(`/cqc-centre/gaps/${gap._id}/assign`, { assignedTo: assignee?._id ?? null })
      .then((res) => {
        if (res.status === 200) {
          setToast?.({
            message: assignee
              ? `Assigned to ${assignee.firstName} ${assignee.lastName}`
              : 'Assignment removed',
          })
          onSaved?.()
        }
      })
      .catch((e) => console.log(e))
      .finally(() => setSaving(false))
  }

  return (
    <Stack gap={2} sx={{ width: { xs: '100%', sm: 480 }, maxWidth: '100%' }}>
      <Typography variant="title2">Assign Gap</Typography>
      <Stack direction="row" gap={1} alignItems="flex-start">
        <GapSeverityChip severity={gap.severity} />
        <Box>
          <Typography variant="body2">{gap.message}</Typography>
          <Typography variant="caption" color="text.secondary">
            The gap resolves automatically once the underlying issue is fixed - assigning it
            just records who is on it.
          </Typography>
        </Box>
      </Stack>
      <EmployeeSelector
        label="Assign to"
        value={assignee}
        onChange={(e, value) => setAssignee(value)}
        fullWidth
        size="small"
      />
      <Stack direction="row" gap={1} justifyContent="flex-end">
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={save} disabled={saving}>
          {saving ? 'Saving…' : assignee ? 'Assign' : gap.assignedTo ? 'Unassign' : 'Assign'}
        </Button>
      </Stack>
    </Stack>
  )
}

export default AssignGapDialog
